import { act } from "react"
import {

  GET_ORDERS_FAIL,
  GET_ORDERS_SUCCESS,

  GET_ORDER_DETAIL_SUCCESS,
  GET_ORDER_DETAIL_FAIL,

  DELETE_ORDER_SUCCESS,
  CONVERT_TO_ORDER_SUCCESS,
  CONVERT_TO_ORDER_FAIL,
  UPDATE_ORDER_SUCCESS

} from "./actionTypes"

const INIT_STATE = {
  orders: [],
  order: {},
  status: 200,
  loading: false
}

const Orders = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload,
      }

    case GET_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_ORDER_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          docs: state.orders.docs.filter(order => order._id !== action.payload._id)
        }
      };

    case CONVERT_TO_ORDER_SUCCESS:

      const index = state.orders.docs.findIndex(order =>
        order.orderCode === action.payload.data.orderCode
      );
      if (index !== -1) {
        state.orders.docs.splice(index, 1); // removes 1 element at found index
      }
      
      return {
        ...state,
        orders: state.orders,
        status: action.payload.status
      }

    case CONVERT_TO_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      
    case GET_ORDER_DETAIL_SUCCESS:
      return {
        ...state,
        order: action.payload,
      }

    case GET_ORDER_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_ORDER_SUCCESS:
      return {
        ...state,
        orders: state.orders.docs.filter(
          order => order._id !== action.payload.id
        ),
      }

    default:
      return state
  }
}

export default Orders
